import React from "react";

import StarRatings from "react-star-ratings";
import { selectTextByLanguage, useGetAvailableTranslation } from "../../hooks/global/Languages";
import { useTranslation } from "react-i18next";

function Answer(props) {
  const { t } = useTranslation();
  let lng = props.lng;
  const answer = props.answer;
  const availableLanguages = useGetAvailableTranslation();

  lng = lng.toUpperCase();

  let questionText = selectTextByLanguage(answer.questionText, lng, availableLanguages);
  let firstValue = answer.answer.value;

  const starColor = "#f8bf2a";
  const numStars = 5;


  const parseScore = (score) => {
    return isNaN(score) ? 0 : parseInt(score);
  };

  return (
    <div>
      {(() => {
        switch (answer.type) {
          case "SCORE":
            return (
              <div className="rate stars center starsAdditional">
                <p><strong>{questionText}</strong></p>
                <StarRatings
                  starRatedColor={starColor}
                  name="rating"
                  numberOfStars={numStars}
                  starDimension={'16'}
                  starSpacing={'1'}
                  rating={parseScore(firstValue)}
                />
              </div>
            );

          case "NPS":
            return (
              <div className="rate stars center margin-top-25">
                <p>
                  <strong><strong>{questionText}</strong> </strong>
                  <br />
                  {firstValue}/10
                </p>
              </div>
            );

          case "CHECKBOX":
            return (
              <div className="rate stars center margin-top-25">
                <p>
                  <strong><strong>{questionText}</strong></strong>
                  <br />
                
                  {firstValue ? t("admin.common.true") : t("admin.common.false")}
                </p>
              </div>
            );
          case "RADIO":
            return (
              <div className="rate stars center margin-top-25">
                <p>
                  <strong><strong>{questionText}</strong></strong>
                  <br />
                  {selectTextByLanguage(answer.answer.text, lng, availableLanguages)}
          
                </p>
              </div>
            );

          case "MULTISELECT":
            return (
              <div className="rate stars center margin-top-25">
                <p>
                  <strong><strong>{questionText}</strong></strong>
                </p>
                <ul>
                  {answer.answer.map((a) => {
                    return <li key={a.value}>{selectTextByLanguage(a.text, lng, availableLanguages)}</li>;
                  })}
                </ul>
              </div>
            );

          default:
            return (
              <div className="rate stars center margin-top-25">
                <p>
                  <strong><strong>{questionText}</strong></strong>
                  <br />
                  {firstValue}
                </p>
              </div>
            );
        }
      })()}
    </div>
  );
}

export default Answer;
